import './_header.scss';
import moment from 'moment';
import logo from '../../assets/Nandus.png';
import { useContext } from 'react';
import { OrderDetailsContext } from '../../context/OrderDetailsContext';

const Header = () => {
  const { orderDetail, slottedOrder, orderType } =
    useContext(OrderDetailsContext);
  const { isError } = useContext(OrderDetailsContext);
  const orderId = orderDetail?.response?.orderId;

  var value = orderDetail?.response?.customerPhoneNo;
  var number = value.replace(/\D/g, '').slice(-10);

  return (
    <header className="header">
      <nav className="headerNavbar">
        <div className={isError ? 'site-logo-big' : 'site-logo'}>
          <img src={logo} alt="" />
        </div>
        {isError !== 'yes' && (
          <>
            <hr className="headerHr" />
            <div className="OrderInfoOuter">
              <div className="headerTagline">
                Fresh and healthy meat is on the way!
              </div>
            </div>

            <div className="orderInfoInner">
              <div className="slottedDelvieryInfo">
                <div className="deliveryDateHeading">your order ID</div>
                <div className="detail">
                  {isError === 'yes' ? (
                    <>...</>
                  ) : (
                    <> : {orderDetail !== [] ? orderId : '...'}</>
                  )}
                </div>
              </div>
              {orderType === 'slotted' ? (
                <>
                  <div className="slottedDelvieryInfo">
                    <div className="deliveryDateHeading">Expected delivery</div>
                    <div className="detail">
                      {isError === 'yes' ? (
                        <>...</>
                      ) : (
                        <>
                          :{' '}
                          {orderType === 'slotted' && (
                            <>
                              {moment(
                                orderDetail?.response?.timeSlotEnd
                              ).format('LT') !== 'Invalid date'
                                ? moment(
                                    orderDetail?.response?.timeSlotEnd
                                  ).format('LT')
                                : '...'}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="slottedDelvieryInfo">
                    <div className="deliveryDateHeading">Expected delivery</div>
                    <>
                      {slottedOrder === 'yes' ? (
                        <div className="detail">
                          {isError === 'yes' ? (
                            <>...</>
                          ) : (
                            <>
                              :{' '}
                              {moment(
                                orderDetail?.response?.timeSlotEnd
                              ).format('LT')}
                            </>
                          )}
                        </div>
                      ) : (
                        <div className="detail">
                          {isError === 'yes' ? (
                            <>...</>
                          ) : (
                            <>
                              :{' '}
                              {orderType === 'express' && (
                                <>
                                  {moment(
                                    orderDetail?.response?.deliveryDatetime
                                  ).format('LT')}
                                </>
                              )}
                            </>
                          )}
                        </div>
                      )}
                    </>
                  </div>
                </>
              )}

              <div className="slottedDelvieryInfo">
                <div className="deliveryDateHeading">your contact number</div>
                <div className="detail">
                  {isError === 'yes' ? <>: ..........</> : <>: {number}</>}
                </div>
              </div>
            </div>
            <hr className="headerHr" />
          </>
        )}
      </nav>
    </header>
  );
};

export default Header;
